export default __webpack_public_path__ + "static/media/P344_P348_P350_P730_23MXXXA_GENERIC_SMALL_.266d74a9.STEP";